export default "__VITE_ASSET__iGDuR63L__"